export default "__VITE_ASSET__e9bdbd97__"